import { UploadProcessesDocument, UploadProcessesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type UploadProcess =
  UploadProcessesQuery['documents']['uploadProcessesConnection']['nodes'][number]

export const useGetUploadProcess = () => {
  const { data, loading, refetch } = useQuery(UploadProcessesDocument, {})

  const result = data?.documents.uploadProcessesConnection.nodes || []

  return {
    uploadProcess: result[result.length - 1],
    loading,
    refetch,
  }
}
